import React from 'react';
import {
  Button,
  ButtonGroup,
  Heading,
  TextStyle
} from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

const RequesterScreenshotConfirmation = ({
  onAccept,
  closeToastContainer,
  intl
}) => {
  return (
    <div className="flex fcol g10 p20">
      <div className="flex-center">
        <div className="flex-center">
          <SVGIcon name="WarningOutline" color="#FFC389" size="xl" />
        </div>
        <div className="flex f11 mlr10">
          <Heading element="h2">
            {getTranslatedText(intl, 'common.warning')}
          </Heading>
        </div>
      </div>
      <div className="flex font-black">
        <TextStyle weight="Medium">
          {getTranslatedText(
            intl,
            'msp.chat.requester.screenshot.confirmation.title'
          )}
        </TextStyle>
      </div>
      <div className="flex fcol font-black g10">
        <ButtonGroup spacing="loose">
          <Button
            primary
            onClick={async () => {
              await onAccept();
              closeToastContainer();
            }}
          >
            {getTranslatedText(intl, 'role.operation.allow')}
          </Button>
          <Button onClick={closeToastContainer}>
            {getTranslatedText(intl, 'common.label.deny')}
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};
export default RequesterScreenshotConfirmation;
